<template>

	<!-- 탭 -->
<!--	<div class="tab swiper-container">
		<ul class="swiper-wrapper">
			<li class="swiper-slide" :class="{ 'active': currentSort === item.sort }" v-for="(item, index) in sortList">
				<a href="javascript:;" @click="doSort( item.sort )">{{ item.name }}</a>
			</li>
		</ul>
	</div>-->

	<div class="sort">
		<a href="javascript:;" :class="{ 'active': currentSort === item.sort }" v-for="(item, index) in sortList" @click="doSort( item.sort )">{{ item.name }}</a>
	</div>

</template>

<script>
export default {
	name: "eduSorter",
	data() {

		let currentSort = this.webUtils.getParameter("sort");
		if ( this.stringUtils.isEmpty(currentSort) ) {
			currentSort = "createDate,DESC";
		}

		const sortList = [];
		sortList.push({
			sort: "createDate,DESC",
			name: "최신순"
		});
		sortList.push({
			sort: "eduTitle,ASC",
			name: "강좌순"
		});
		sortList.push({
			sort: "views,DESC",
			name: "조회순"
		});

		return {
			currentSort,
			sortList,
		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		doSort ( _sort ) {
			this.currentSort = _sort;
			this.$emit("doSort", _sort);
		}

	}
}
</script>

<style scoped>

</style>